'use client'

import { ButtonV4 } from '@/components/v4/atoms/button/button'
import s from './cta.module.css'
import cx from 'classnames'
import { redirect } from 'next/navigation'
import { ROUTES } from '@/constants'
import { getRelAttribute } from '@/utils/getRelAttribute'

export type CTATheme = 'light' | 'dark'

type Props = {
  title?: string
  content?: string
  buttonText?: string
  buttonLink?: string
  theme?: CTATheme
  openInNewTab?: boolean
  nofollow?: boolean
  sponsored?: boolean
}

export const CTABlockV3 = ({
  title = 'Title',
  content = '',
  buttonText = 'Button text',
  buttonLink,
  theme = 'light',
  openInNewTab,
  nofollow,
  sponsored,
}: Props) => {
  const isDark = theme === 'dark'
  const rel = getRelAttribute({
    nofollow,
    sponsored,
    rel: openInNewTab ? 'noopener noreferrer' : undefined,
  })

  return (
    <div
      className={cx(s.wrapper, {
        [s.wrapperDark]: isDark,
      })}
    >
      <div className={s.container}>
        <p
          className={cx(s.title, {
            [s.titleDark]: isDark,
          })}
        >
          {title}
        </p>
        <p
          className={cx(s.content, {
            [s.contentDark]: isDark,
          })}
        >
          {content}
        </p>
        <ButtonV4
          href={buttonLink}
          onClick={!buttonLink ? () => redirect(ROUTES.HOME) : undefined}
          className={s.button}
          variant={isDark ? 'light' : 'dark'}
          target={openInNewTab ? '_blank' : undefined}
          rel={rel}
        >
          {buttonText}
        </ButtonV4>
      </div>
    </div>
  )
}

